export default __webpack_public_path__ + "static/media/3.0843c515.jpg";